var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunityManagment = function SvgCommunityManagment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8 12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9700",
    d: "M36.79 10.376h-9.561c-.424 0-.83.17-1.129.473a1.62 1.62 0 0 0-.466 1.14v10.23a1.61 1.61 0 0 0 1.267 1.58V35.85c0 1.14.915 2.065 2.044 2.065h6.128a2.054 2.054 0 0 0 2.043-2.065V23.798a1.61 1.61 0 0 0 1.268-1.579V11.99a1.62 1.62 0 0 0-.467-1.14 1.6 1.6 0 0 0-1.128-.473Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.009,
    cy: 6.08,
    r: 4.274,
    fill: "#FF9700",
    transform: "rotate(-45 32.01 6.08)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DC",
    d: "M52.112 10.376h-9.565c-.881 0-1.596.722-1.596 1.613v10.23c0 .764.53 1.422 1.27 1.58v17.027c-.001.597.233 1.17.65 1.591s.984.66 1.575.66h5.762a2.22 2.22 0 0 0 1.577-.658c.419-.423.654-.996.654-1.593V23.798a1.61 1.61 0 0 0 1.27-1.579V11.99c0-.89-.716-1.613-1.597-1.613Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.331,
    cy: 6.081,
    r: 4.274,
    fill: "#00A1DC",
    transform: "rotate(-45 47.331 6.081)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "M21.453 10.376h-9.565c-.423 0-.83.17-1.129.473a1.62 1.62 0 0 0-.467 1.14v10.23c0 .764.53 1.422 1.27 1.58V35.85c0 1.14.914 2.065 2.042 2.065h6.127a2.054 2.054 0 0 0 2.043-2.065V23.798a1.61 1.61 0 0 0 1.27-1.579V11.99c0-.888-.712-1.61-1.591-1.613Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.668,
    cy: 6.082,
    fill: "#50CDFF",
    rx: 4.254,
    ry: 4.293,
    transform: "rotate(-13.28 16.668 6.082)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "M62.911 37.907c-3.793-.76-6.435-.886-10.104-1.25a26 26 0 0 0-2.533-.127c-5.503 0-9.995 1.758-14.341 3.456q-2.416.931-4.916 1.602c-2.764.74-5.612 1.774-6.958 2.618-1.221.764-1.68 1.696-1.368 2.773.46 1.568 2.305 2.016 6.091 2.016 2.532 0 5.705-.466 9.014-.797l1.609-.159c2.093.143-8.386 2.032-11.495 2.032-3.576 0-5.88-.926-6.558-2.587-1.038-2.554 1.85-4.209 1.85-4.209-.137-.04-14.63-4.077-17.278-4.72a7.4 7.4 0 0 0-1.76-.215c-2.103 0-3.812.927-4.064 2.2-.121.616.018 1.825 2.324 2.995L22.6 52.947a52 52 0 0 1 2.099.932c2.24 1.034 4.555 2.101 6.707 2.101.883 0 1.763-.105 2.621-.316 1.56-.383 5.506-1.678 9.682-3.047 4.064-1.334 8.269-2.71 9.95-3.133a17 17 0 0 1 4.16-.488c1.983 0 2.54.846 4.173 1.655q.073.043.15.076h.01c.144.059.298.089.454.088h.082a1.245 1.245 0 0 0 1.235-1.248V39.133a1.25 1.25 0 0 0-1.012-1.226"
  }))));
};
export default SvgCommunityManagment;